<div class="signature-modal">
  @if (selectedMethod === null) {
    <!-- Wybór metody podpisu -->
    <h2 mat-dialog-title>{{ 'Annex.SignatureMethod' | translate }}</h2>

    <mat-dialog-content>
      <div class="method-options">
        @if (electronicAllowed) {
          <div class="method-card" (click)="onSelectMethod(signatureMethod.Electronic)">
            <mat-icon class="method-icon">draw</mat-icon>
            <h3>{{ 'Annex.ElectronicSignature' | translate }}</h3>
            <p>{{ 'Annex.ElectronicSignatureDescription' | translate }}</p>
          </div>
        }
        @if (smsAllowed) {
          <div class="method-card" (click)="onSelectMethod(signatureMethod.SMS)">
            <mat-icon class="method-icon">sms</mat-icon>
            <h3>{{ 'Annex.SMSSignature' | translate }}</h3>
            <p>{{ 'Annex.SMSSignatureDescription' | translate }}</p>
          </div>
        }
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">
        {{ 'Cancel' | translate }}
      </button>
    </mat-dialog-actions>
  }

  @if (selectedMethod === signatureMethod.Electronic) {
    <!-- Sekcja podpisu elektronicznego -->
    <h2 mat-dialog-title>{{ 'Annex.ElectronicSignature' | translate }}</h2>

    <mat-dialog-content>
      <div class="signature-pad-section">
        <app-signature-pad></app-signature-pad>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button (click)="onBackToMethodSelection()">
        <mat-icon>arrow_back</mat-icon>
        {{ 'Back' | translate }}
      </button>
      <button mat-raised-button color="accent" type="button" (click)="onClearSignaturePadClick()" [disabled]="isSignaturePadEmpty">
        <mat-icon>clear</mat-icon>
        {{ 'Clear' | translate }}
      </button>
      <button mat-raised-button color="primary" type="button" (click)="onSignWithPadClick()" [disabled]="!isSignatureValid">
        <mat-icon>check</mat-icon>
        {{ 'Annex.ConfirmSignature' | translate }}
      </button>
    </mat-dialog-actions>
  }

  @if (selectedMethod === signatureMethod.SMS) {
    <!-- Sekcja weryfikacji SMS -->
    <h2 mat-dialog-title>{{ 'Annex.SMSSignature' | translate }}</h2>

    <mat-dialog-content>
      <div class="sms-verification-section">
        @if (isVerificationCodeSent) {
          <p class="sms-info">{{ 'Annex.SMSVerificationInfo' | translate }}</p>
        }

        <form [formGroup]="verificationCodeFormGroup">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ 'VerificationCode' | translate }}</mat-label>
            <input id="verificationCode" matInput placeholder="{{ 'VerificationCode' | translate }}" formControlName="verificationCode" minlength="6" maxlength="6" />
            @if (verificationCode.invalid && verificationCode.touched) {
              <mat-error>
                {{ 'InvalidField' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </form>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button (click)="onBackToMethodSelection()">
        <mat-icon>arrow_back</mat-icon>
        {{ 'Back' | translate }}
      </button>
      <button mat-raised-button color="accent" (click)="onSendVerificationCodeClick()">
        <mat-icon>send</mat-icon>
        {{ 'WAD-SendVerificationCode' | translate }}
      </button>
      <button mat-raised-button color="primary" (click)="onVerifyCodeClick()" [disabled]="!isVerifyButtonEnabled">
        <mat-icon>check</mat-icon>
        {{ 'WAD-VerifyCode' | translate }}
      </button>
    </mat-dialog-actions>
  }
</div>
